import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import paymentService from "./paymentService";
import invoiceService from "../invoice/invoiceService";

export const getPayment = createAsyncThunk(
  "payment/get-payments",
  async (thunkAPI) => {
    try {
      return await paymentService.getPayments();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createPayment = createAsyncThunk(
  "payment/create-payment",
  async (paymentData, thunkAPI) => {
    try {
      return await paymentService.createPayments(paymentData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAPayment = createAsyncThunk(
  "payment/update-payment",
  async (payment, thunkAPI) => {
    try {
      return await paymentService.updatePayments(payment);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAPayment = createAsyncThunk(
  "payment/get-payment",
  async (id, thunkAPI) => {
    try {
      return await paymentService.getPayments(id); // Fixed from getBrand
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAPayment = createAsyncThunk(
  "payment/delete-payment",
  async (id, thunkAPI) => {
    try {
      return await paymentService.deletePayments(id); // Fixed from deleteBrand
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getPaymentOverview = createAsyncThunk(
  "paymentOverview/get-paymentOverview",
  async (thunkAPI) => {
    try {
      return await paymentService.getPaymentOverview();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getPaymentSuccess = createAsyncThunk(
  "paymentSuccess/get-paymentSuccess",
  async (thunkAPI) => {
    try {
      return await paymentService.getPaymentSuccess();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getPaymentReceipt = createAsyncThunk(
  "paymentReceipt/get-paymentReceipt",
  async (thunkAPI) => {
    try {
      return await paymentService.getPaymentReceipt();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getViewInvoice = createAsyncThunk(
  "viewInvoice/get-viewInvoice",
  async (id, thunkAPI) => {
    try {
      return await invoiceService.getViewInvoice(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getInvoiceData = createAsyncThunk(
  "invoiceData/get-invoiceData",
  async (id, thunkAPI) => {
    try {
      return await paymentService.getInvoiceData(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getInvoiceReceiptPayment = createAsyncThunk(
  "invoiceReceiptData/get-invoiceReceiptData",
  async (id, thunkAPI) => {
    try {
      return await paymentService.getInvoiceReceiptPayment(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getInvoiceReceiptInfo = createAsyncThunk(
  "invoiceReceiptInfo/get-invoiceReceiptInfo",
  async (id, thunkAPI) => {
    try {
      return await paymentService.getInvoiceReceiptInfo(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const uploadCsvs = createAsyncThunk(
  "payment/upload-csv",
  async (params, thunkAPI) => {
    try {
      return await paymentService.uploadCsvs(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

export const csvDownloads = createAsyncThunk(
  "payment/csv-download",
  async (thunkAPI) => {
    try {
      return await paymentService.csvDownloads();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// export const csvDownloads = createAsyncThunk(
//   "payment/csv-download",
//   async (_, thunkAPI) => {
//     try {
//       const response = await paymentService.csvDownloads();
//       return response; // Ensure this is the CSV string or Blob
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

export const resetState = createAction("Reset_all");

const initialState = {
  payments: [],
  paymentOverviews: [],
  paymentSuccess: [],
  paymentReceipt: [],
  uploadedDatas: [],
  csvDatas: [],
  viewinvoices: [],
  loading: false,
  Loading: false,
  invoicedatas: [],
  invoiceReceipt: [],
  invoiceReceiptInfo: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPayment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.payments = action.payload;
      })
      .addCase(getPayment.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createPayment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdPayment = action.payload;
      })
      .addCase(createPayment.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAPayment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.paymentName = action.payload.title;
      })
      .addCase(getAPayment.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAPayment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedPayment = action.payload;
      })
      .addCase(updateAPayment.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAPayment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedBrand = action.payload;
      })
      .addCase(deleteAPayment.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getPaymentOverview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPaymentOverview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.paymentOverviews = action.payload;
      })
      .addCase(getPaymentOverview.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getPaymentSuccess.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPaymentSuccess.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.paymentSuccess = action.payload;
      })
      .addCase(getPaymentSuccess.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getPaymentReceipt.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPaymentReceipt.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.paymentReceipt = action.payload;
      })
      .addCase(getPaymentReceipt.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getViewInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getViewInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.viewinvoices = action.payload;
      })
      .addCase(getViewInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getInvoiceData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvoiceData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.invoicedatas = action.payload;
      })
      .addCase(getInvoiceData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getInvoiceReceiptPayment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvoiceReceiptPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.invoiceReceipt = action.payload;
      })
      .addCase(getInvoiceReceiptPayment.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getInvoiceReceiptInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvoiceReceiptInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.invoiceReceiptInfo = action.payload;
      })
      .addCase(getInvoiceReceiptInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(csvDownloads.pending, (state) => {
        state.loading = true;
      })
      .addCase(csvDownloads.fulfilled, (state, action) => {
        state.loading = false;
        state.isError = false;
        state.isSuccess = true;
        state.csvDatas = action.payload;
      })
      .addCase(csvDownloads.rejected, (state, action) => {
        state.loading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(uploadCsvs.pending, (state) => {
        state.Loading = true;
      })
      .addCase(uploadCsvs.fulfilled, (state, action) => {
        state.Loading = false;
        state.isError = false;
        state.isSuccess = true;
        state.uploadedDatas = action.payload;
      })
      .addCase(uploadCsvs.rejected, (state, action) => {
        state.Loading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default paymentSlice.reducer;
